import "zone.js";
import { enableProdMode, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from "@angular/core";
import { environment } from "@apps/patient-core/src/app/environments/environment";
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { CurrencyPipe } from "@angular/common";
import { PatientAppComponent } from "./app/app.component";
import { HttpInterceptorProviders } from "@apps/patient-core/src/app/http-interceptors";
import { APP_ROUTES } from "./app/app.routing";
import { PatientAppInitService } from "./app/services/derived/app-init.service";
import * as PROVIDERS from "@apps/patient-core/generate-abstract-providers";

if (environment.production) {
  enableProdMode();
}

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

bootstrapApplication(PatientAppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    HttpInterceptorProviders,
    CurrencyPipe,
    ...PROVIDERS.PATIENT_PROVIDERS,
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const appInitService = inject(PatientAppInitService);
      return appInitService.init();
    }),
    importProvidersFrom(BrowserModule, BrowserAnimationsModule),
  ],
}).catch((err) => console.error(err));
